import {
  takeLatest, call, put, all,
} from 'redux-saga/effects';
import HealthcheckService from '@rootCommon/services/healthcheck-service';
import * as actions from '@actions/healthcheck';
import { HealthcheckInfo } from '@rootCommon/types/healthcheck';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch healthcheck data
function* fetchHealthcheckAsync() {
  try {
    const healthcheck: HealthcheckInfo = yield call(HealthcheckService.getHealthcheckInfo);

    yield put(actions.fetchHealthcheck.success(healthcheck));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchHealthcheck.failure(error));
  }
}

function* watchFetchHealthcheck() {
  yield takeLatest(actions.fetchHealthcheck.request, fetchHealthcheckAsync);
}

// all
export function* watchHealthcheck(): SagaGenerator {
  yield all([watchFetchHealthcheck()]);
}

export default watchHealthcheck;
